import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "full"]
  static values = {
    moreText: { type: String, default: "Mehr anzeigen" },
    lessText: { type: String, default: "Weniger anzeigen" }
  }

  connect() {
    // Stelle sicher, dass das Template beim Start versteckt ist
    if (this.hasFullTarget) {
      this.hideFullContent()
    }
  }

  toggle(event) {
    event.preventDefault()
    
    if (!this.hasContentTarget || !this.hasFullTarget) {
      console.warn("read-more: Missing required targets")
      return
    }

    // Toggle zwischen kurzem und vollständigem Inhalt
    if (this.contentTarget.style.display === "none") {
      // Zeige kurzen Inhalt, verstecke vollen
      this.showShortContent()
    } else {
      // Zeige vollen Inhalt, verstecke kurzen
      this.showFullContent()
    }
  }

  showFullContent() {
    // Verstecke kurzen Inhalt
    this.contentTarget.style.display = "none"
    
    // Hole Inhalt aus dem Template und zeige ihn
    const template = this.fullTarget
    const content = template.content.cloneNode(true)
    
    // Erstelle einen Container für den vollständigen Inhalt, falls noch nicht vorhanden
    if (!this.fullContentContainer) {
      this.fullContentContainer = document.createElement('div')
      this.fullContentContainer.classList.add('full-content-container')
      template.parentNode.insertBefore(this.fullContentContainer, template)
    }
    
    // Leere den Container und füge neuen Inhalt hinzu
    this.fullContentContainer.innerHTML = ''
    this.fullContentContainer.appendChild(content)
    this.fullContentContainer.style.display = "block"
  }

  showShortContent() {
    // Zeige kurzen Inhalt
    this.contentTarget.style.display = "block"
    
    // Verstecke vollen Inhalt
    if (this.fullContentContainer) {
      this.fullContentContainer.style.display = "none"
    }
  }

  hideFullContent() {
    // Stelle sicher, dass der Container versteckt ist beim Start
    if (this.fullContentContainer) {
      this.fullContentContainer.style.display = "none"
    }
  }
}

